export default __webpack_public_path__ + "static/media/donkeygeek.152d6396.webp";